import { applyClassName, styled, type StyledElementProps } from '@glitz/react';
import * as React from 'react';
import { SiteTheme } from 'webapp/theme';
import infoSvg from './generic/info.svg';
import circleFilledSvg from './generic/circle-filled.svg';
import circleSvg from './generic/circle.svg';
import closeSvg from './generic/close.svg';
import searchSvg from './generic/search.svg';
import sortSvg from './generic/sort.svg';
import shareSvg from './generic/share.svg';
import heartSvg from './generic/heart.svg';
import chevronDownSvg from './generic/chevron-down.svg';
import nnShareSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/share.svg';
import nnHeartSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/heart.svg';
import nnCircleFilledSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/circle-filled.svg';
import nnCircleSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/circle.svg';
import crossIconSvg from './generic/cross.svg';
import plusSvg from './generic/plus-old.svg';
import minusSvg from './generic/minus-old.svg';
import alertSvg from './generic/alert-old.svg';
import checkSvg from './generic/check-old.svg';
import nnCheckSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/check.svg';
import slickCheckSvg from './generic/check.svg';
import discardSvg from './generic/discard-old.svg';
import nnCloseSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/close.svg';
import nnSearchSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/search.svg';
import nnChevronDownSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/chevron-down.svg';
import filterSvg from './generic/filter.svg';
import filmSvg from './generic/film.svg';
import lsFilterSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/filter.svg';
import lsCloseSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/close.svg';
import lsSearchSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/search.svg';
import lineArrowLeftSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/line-arrow-left.svg';
import lsSortSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/sort.svg';
import lsChevronDownSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/chevron-down.svg';
import lsHeartSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/heart.svg';
import { OrderIcon, ShippingBirdIcon } from 'nordicnest/shared/icons';
import { ShippingBox } from 'svenssons/shared/icons';
import menuSvg from './generic/hamburger.svg';
import nnMenuSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/hamburger.svg';
import lsMenuSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/menu.svg';
import cartSvg from './generic/cart.svg';
import nnCartSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/cart.svg';
import lsCartSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/cart.svg';
import userSvg from './generic/user.svg';
import nnUserSvg from '../../../sites/nordicnest/src/app/shared/icons/glyphs/user.svg';
import lsUserSvg from '../../../sites/svenssons/src/app/shared/icons/glyphs/user.svg';
import checkCircleSvg from './generic/check-circle.svg';
import upVoteSvg from './generic/thumbs-up.svg';
import downVoteSvg from './generic/thumbs-down.svg';
import reportSvg from './generic/slash.svg';
import lineArrowRightSvg from './generic/line-arrow-right.svg';
import augmentedRealitySvg from './generic/augmented-reality.svg';
import fullscreenSvg from './generic/fullscreen.svg';
import dimensionsSvg from './generic/dimensions.svg';

export { Spinner } from './spinner';

interface IconMap {
  [key: string]: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
}

export function normalize(Icon: React.FunctionComponent<StyledElementProps & React.SVGAttributes<SVGElement>>) {
  return styled(applyClassName(Icon), {
    display: 'block',
    height: '1.5em',
    width: '1.5em',
  });
}

const filterIcon: IconMap = {
  [SiteTheme.NordicNest]: filterSvg,
  [SiteTheme.Kitchentime]: filterSvg,
  [SiteTheme.Lightshop]: lsFilterSvg,
  [SiteTheme.Svenssons]: lsFilterSvg,
};
export const FilterIcon = normalize(filterIcon[__SITE__] || filterSvg);

const closeIcon: IconMap = {
  [SiteTheme.NordicNest]: nnCloseSvg,
  [SiteTheme.Kitchentime]: closeSvg,
  [SiteTheme.Lightshop]: lsCloseSvg,
  [SiteTheme.Svenssons]: lsCloseSvg,
};
export const CloseIcon = normalize(closeIcon[__SITE__] || closeSvg);

export const CircleIcon = () => {
  let Icon;
  switch (__SITE__) {
    case SiteTheme.NordicNest:
      Icon = normalize(nnCircleSvg);
      return <Icon />;
    default:
      Icon = normalize(circleSvg);
      return <Icon />;
  }
};

export const CrossIcon = normalize(crossIconSvg);

export const CircleFilledIcon = () => {
  let Icon;
  switch (__SITE__) {
    case SiteTheme.NordicNest:
      Icon = normalize(nnCircleFilledSvg);
      return <Icon />;
    default:
      Icon = normalize(circleFilledSvg);
      return <Icon />;
  }
};
const chevronDownIcon: IconMap = {
  [SiteTheme.NordicNest]: nnChevronDownSvg,
  [SiteTheme.Kitchentime]: chevronDownSvg,
  [SiteTheme.Lightshop]: lsChevronDownSvg,
  [SiteTheme.Svenssons]: lsChevronDownSvg,
};

export const Film = normalize(filmSvg);

export const InfoIcon = normalize(infoSvg);

export const ChevronDownIcon = normalize(chevronDownIcon[__SITE__] || chevronDownSvg);

export const ArrowUp = styled(ChevronDownIcon, {
  transform: 'rotate(180deg)',
});

export const ArrowLeft = styled(ChevronDownIcon, {
  transform: 'rotate(90deg)',
});

export const ArrowRight = styled(ChevronDownIcon, {
  transform: 'rotate(270deg)',
});

export const LineArrowRight = normalize(lineArrowRightSvg);

const backIcon: IconMap = {
  [SiteTheme.NordicNest]: ArrowLeft,
  [SiteTheme.Kitchentime]: ArrowLeft,
  [SiteTheme.Lightshop]: normalize(lineArrowLeftSvg),
  [SiteTheme.Svenssons]: normalize(lineArrowLeftSvg),
};
export const BackIcon = backIcon[__SITE__] || ArrowLeft;

const sortIcon: IconMap = {
  [SiteTheme.NordicNest]: sortSvg,
  [SiteTheme.Kitchentime]: sortSvg,
  [SiteTheme.Lightshop]: lsSortSvg,
  [SiteTheme.Svenssons]: lsSortSvg,
};
export const SortIcon = normalize(sortIcon[__SITE__] || sortSvg);

const searchIcon: IconMap = {
  [SiteTheme.NordicNest]: nnSearchSvg,
  [SiteTheme.Kitchentime]: searchSvg,
  [SiteTheme.Lightshop]: lsSearchSvg,
  [SiteTheme.Svenssons]: lsSearchSvg,
};
export const SearchIcon = normalize(searchIcon[__SITE__] || searchSvg);

export const ArrowDown = ChevronDownIcon;

export const Discard = normalize(discardSvg);

export const SlickCheck = normalize(slickCheckSvg);

const checkIcon: IconMap = {
  [SiteTheme.NordicNest]: nnCheckSvg,
  [SiteTheme.Kitchentime]: nnCheckSvg,
  [SiteTheme.Lightshop]: checkSvg,
  [SiteTheme.Svenssons]: checkSvg,
};
export const CheckIcon = styled(normalize(checkIcon[__SITE__] || checkSvg), {
  minHeight: '1.5em',
  minWidth: '1.5em',
});

const shareIcon: IconMap = {
  [SiteTheme.NordicNest]: nnShareSvg,
  [SiteTheme.Kitchentime]: nnShareSvg,
  [SiteTheme.Lightshop]: shareSvg,
  [SiteTheme.Svenssons]: shareSvg,
};
export const ShareIcon = normalize(shareIcon[__SITE__] || nnShareSvg);

const heartIcon: IconMap = {
  [SiteTheme.NordicNest]: nnHeartSvg,
  [SiteTheme.Kitchentime]: heartSvg,
  [SiteTheme.Lightshop]: lsHeartSvg,
  [SiteTheme.Svenssons]: lsHeartSvg,
};
export const HeartIcon = normalize(heartIcon[__SITE__] || heartSvg);

export const Alert = normalize(alertSvg);
export const Minus = normalize(minusSvg);
export const Plus = normalize(plusSvg);

const partialDeliveryIcon: IconMap = {
  [SiteTheme.NordicNest]: ShippingBirdIcon,
  [SiteTheme.Kitchentime]: OrderIcon,
  [SiteTheme.Lightshop]: ShippingBox,
  [SiteTheme.Svenssons]: ShippingBox,
};
export const PartialDeliveryIcon = partialDeliveryIcon[__SITE__];

const menuIcon: IconMap = {
  [SiteTheme.NordicNest]: nnMenuSvg,
  [SiteTheme.Kitchentime]: menuSvg,
  [SiteTheme.Lightshop]: lsMenuSvg,
  [SiteTheme.Svenssons]: lsMenuSvg,
};
export const MenuIcon = normalize(menuIcon[__SITE__] || menuSvg);

const cartIcon: IconMap = {
  [SiteTheme.NordicNest]: nnCartSvg,
  [SiteTheme.Kitchentime]: cartSvg,
  [SiteTheme.Lightshop]: lsCartSvg,
  [SiteTheme.Svenssons]: lsCartSvg,
};
export const CartIcon = normalize(cartIcon[__SITE__] || cartSvg);

const userIcon: IconMap = {
  [SiteTheme.NordicNest]: nnUserSvg,
  [SiteTheme.Kitchentime]: userSvg,
  [SiteTheme.Lightshop]: lsUserSvg,
  [SiteTheme.Svenssons]: lsUserSvg,
};
export const UserIcon = normalize(userIcon[__SITE__] || userSvg);

export const CheckCircleIcon = normalize(checkCircleSvg);

export const UpVote = normalize(upVoteSvg);

export const DownVote = normalize(downVoteSvg);

export const Report = normalize(reportSvg);

export const ARIcon = augmentedRealitySvg;

export const FullscreenIcon = fullscreenSvg;

export const DimensionsIcon = dimensionsSvg;
